export class Sorts {
  static byJapanAlpha(a: any, b: any, name: string) {
    return a[name].localeCompare(b[name], 'ja');
  }
}
